// extracted by mini-css-extract-plugin
export default {"normal":"full-link_normal__+VNMg","active":"full-link_active__YCSW8","dark":"full-link_dark__5MX++"};